module.exports = __webpack_public_path__ + "img/sales.360aa462.svg";